<template>
  <div>
    <Modal
      :width="500"
      :value="modalOpen"
      :title="modalData.title"
      :subtitle="modalData.subtitle"
      :cta-text="modalData.ctaText"
      :cancel-hidden="modalData.cancelHidden"
      @cancel="modalOpen = false"
      dialogIcon="danger"
      @confirm="confirmModal">
    </Modal>

    <ul class="tree" v-if="pageTree.length > 0">
      <MultiStepFormTreeNode
        @openModal="openModal"
        @recomputeLastPageMap="computeLastPageMap"
        :node.sync="pageTree[0]"
        :parent="null"
        :lastPageMap="lastPageMap"
        :form-template="formTemplate"
        :form-text-color="formTextColor"></MultiStepFormTreeNode>
    </ul>
  </div>
</template>

<script>
  import MultiStepFormTreeNode from "./MultiStepFormTreeNode.vue";
  import Modal from "@/components/custom/Modal.vue";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    components: { MultiStepFormTreeNode, Modal },
    props: {
      pageTree: {
        type: Array,
        required: true,
      },
      formTemplate: {
        type: String,
        default: "dark",
      },
      formTextColor: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        modalOpen: false,
        modalData: {},
        styleElement: null,
        lastPageMap: {},
      };
    },
    computed: {
      tinymceCss() {
        return this.$store.state.tinymceCss;
      },
    },
    watch: {
      tinymceCss: {
        immediate: true,
        handler(newCss) {
          this.updateStyles(newCss);
        },
      },
      pageTree: {
        deep: true,
        immediate: true,
        handler() {
          this.computeLastPageMap();
        },
      },
    },
    beforeDestroy() {
      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    },
    methods: {
      updateStyles(css) {
        if (!this.styleElement) {
          this.styleElement = document.createElement("style");
          document.head.appendChild(this.styleElement);
        }

        this.styleElement.innerHTML = this.scopeCss(css, ".content-preview");
      },
      scopeCss(css, scopeSelector) {
        return css.replace(/(^|\})\s*([^\{]+)/g, (match, closingBracket, selectors) => {
          if (closingBracket) {
            return `${closingBracket} ${selectors
              .split(",")
              .map(sel => `${scopeSelector} ${sel.trim()}`)
              .join(",")}`;
          }

          return `${scopeSelector} ${selectors}`;
        });
      },
      openModal(data) {
        this.modalOpen = true;
        this.modalData = data;
      },
      confirmModal() {
        this.modalOpen = false;
        if (this.modalData.delete) {
          const children = cloneDeep(this.modalData.parent.children);
          this.modalData.parent.children = [];

          this.$nextTick(() => {
            children.splice(this.modalData.index, 1);
            this.modalData.parent.children = children;
          });
        }
      },
      computeLastPageMap() {
        const map = {};
        const roots = Array.isArray(this.pageTree) ? this.pageTree : [];

        const traverse = (node, lastPageId) => {
          let currentLastPageId = lastPageId;
          if (node && node.pageType === "page" && node.id) {
            currentLastPageId = node.id;
          }

          const hasChildren = Array.isArray(node?.children) && node.children.length > 0;
          if (hasChildren) {
            node.children.forEach(child => traverse(child, currentLastPageId));
          } else if (currentLastPageId) {
            map[currentLastPageId] = true;
          }
        };

        roots.forEach(root => traverse(root, null));
        this.lastPageMap = map;
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>

